export const PhoneCountryCodes = {
    US: 1,
    CA: 1,
    CN: 86,
    MY: 60,
    MX: 52,
    VN: 84
};

export const CountryFormattedPhoneNumberMaxLength = {
    US: 14,
    CA: 14,
    CN: 14,
    MY: 12,
    MX: 12,
    VN: 12
};

export const CountryNames = {
    US: 'US',
    CA: 'Canada',
    CN: 'China',
    MY: 'Malaysia',
    MX: 'Mexico',
    VN: 'Vietnam'
};
